import comp from "./InlineMoreItemsWithTooltip";
export default comp;
